import { render, staticRenderFns } from "./Case3.vue?vue&type=template&id=3f9b98a6&scoped=true&"
import script from "./Case3.vue?vue&type=script&lang=js&"
export * from "./Case3.vue?vue&type=script&lang=js&"
import style0 from "./Case3.vue?vue&type=style&index=0&id=3f9b98a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9b98a6",
  null
  
)

export default component.exports